import React from "react";
import Picture from "../../../shared/components/Picture";
import LoadingDisplay from "../../../shared/components/LoadingDisplay";
import MatchStripLoader from "../MatchStrip/loader";

function MatchGroupLoader({ stripCount = 1, isMediumLargeMin }) {
  return (
    <div className="mls-c-schedule__match-group">
      <div className="mls-c-schedule__match-header">
        <LoadingDisplay width="10" />
      </div>
      {[...Array(stripCount)].map((loader, index) => {
        return <MatchStripLoader key={`${loader}-${index}`} />;
      })}
    </div>
  );
}

export default MatchGroupLoader;
